/* IntelApps — Footer with i18n support */
import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n.js';

export default function Footer() {
  const { t } = useI18n();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <Link to="/" className="brand" style={{ marginBottom: 16 }}>
              <span className="brand-mark" aria-hidden="true">
                <img src="/assets/Logo.png" alt="" />
              </span>
              IntelApps
            </Link>
            <p className="footer-tagline">{t.footer.tagline}</p>
            <div className="badges" style={{ marginTop: 20 }}>
              <span className="badge">Hiring · 4 roles</span>
            </div>
          </div>
          <div>
            <h5>{t.footer.practice}</h5>
            <ul>
              <li><Link to="/services">AI / ML</Link></li>
              <li><Link to="/services">Mobile</Link></li>
              <li><Link to="/services">Web</Link></li>
              <li><Link to="/services">Blockchain</Link></li>
            </ul>
          </div>
          <div>
            <h5>{t.footer.company}</h5>
            <ul>
              <li><Link to="/team">Team</Link></li>
              <li><Link to="/work">Work</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <h5>{t.footer.contact}</h5>
            <ul>
              <li><a href="mailto:developer@intelapps.ai">developer@intelapps.ai</a></li>
              <li><Link to="/discuss-project">Dover, DE</Link></li>
              <li>
                <a
                  href="https://www.linkedin.com/company/intelapps-ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn ↗
                </a>
              </li>
              {/* <li>
                <a
                  href="https://github.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub ↗
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>{t.footer.rights}</span>
          <span>{t.footer.shipped}</span>
        </div>
      </div>
    </footer>
  );
}
